import _ from 'lodash';
import { bindActionCreators } from 'redux';

import {
  CONNECT_WEBSOCKET,
  DISCONNECT_WEBSOCKET,
} from '../constants/ActionTypes';
import ChannelActionCreators from './ChannelActionCreators';
import * as ActionCreators from './ActionCreators';
import WebSocketClient from '../websocket';
import { PATIENT_ID } from '../constants/RoleConstants';
import i18n from '../config/i18n';

const websocketReceiveAckMessage = updatedChUserInfo => (dispatch, getState) => {
  const { channelId } = updatedChUserInfo;
  const { ackChannelRead } = ChannelActionCreators;
  const { currentChannelId } = getState().channel;

  // NOTE:
  // only update user seen message information when user in the active channel
  if (currentChannelId === channelId) {
    dispatch(ackChannelRead(updatedChUserInfo));
  }
};

const websocketReceiveUpdateTitle = updatedChannel => (dispatch, getState) => {
  const { id: channelId, displayName } = updatedChannel;
  const { channels } = getState().channel;
  const { updateChannel } = ChannelActionCreators;
  const idx = _.findIndex(channels, { id: channelId });
  if (idx === -1) {
    // NOTE: this channel doesn't exist for this user
  } else {
    dispatch(updateChannel({ channelId, displayName }));
  }
};

const websocketSendAckNewMessage = (channelId, userId) => (dispatch, getState) => {
  if (!getState().websocket.connected) return;

  WebSocketClient.sendAckMsg(channelId, userId);
};

const websocketReceiveNewMessage = msg => (dispatch, getState) => {
  const { channelId, creatorId } = msg;
  const { currentChannelId, channels } = getState().channel;
  const userId = parseInt(getState().user.userId, 10);
  const {
    updateChannel,
    createChannelMessage,
  } = ChannelActionCreators;
  const idx = _.findIndex(channels, { id: channelId });

  if (userId === creatorId || idx === -1) {
    // NOTE:
    // We don't need to handle this case because this websocket event is just
    // caused by this user's new message or this channel doesn't exist for this user
    return;
  }

  if (currentChannelId !== channelId) {
    dispatch(updateChannel({ channelId, unReadCnt: channels[idx].unReadCnt + 1 }));
  } else {
    // NOTE:
    // In this case, the user is in the active channel, so
    // we do two things, append new message into the active channel
    // and ack back server we read the new message immediately.
    dispatch(createChannelMessage({ channelId, msg }));
    dispatch(websocketSendAckNewMessage(channelId, userId));
  }
  dispatch(updateChannel({ channelId, lastMsg: msg }));
};

const websocketReceiveNewMember = newMembers => (dispatch, getState) => {
  const { channelId } = newMembers[0];
  const { currentChannelId, channels } = getState().channel;
  const {
    createChannelMembers,
    fetchChannels,
    updateChannel,
  } = ChannelActionCreators;
  const idx = _.findIndex(channels, { id: channelId });

  if (idx === -1) {
    // NOTE: this means the current user is just added in a channel
    // and the current user don't have that channel before for sure
    dispatch(fetchChannels());
    return;
  }

  // NOTE: we don't need to handle this realtime event if user
  // haven't clicked any channel or in another channel.
  if (currentChannelId === channelId) {
    dispatch(createChannelMembers(newMembers));
  }
  dispatch(updateChannel({
    channelId,
    membersCount: channels[idx].membersCount + newMembers.length,
    hasPatient:
      channels[idx].hasPatient || newMembers.some(member => member.user.roleId === PATIENT_ID),
  }));
};

const websocketReceiveDeletedMember = member => (dispatch, getState) => {
  const { channelId } = member;
  const {
    channel: { currentChannelId, channels },
    user: { userId },
  } = getState();
  const {
    deleteChannelMember,
    updateChannel,
    setCurrentChannel,
    deleteChannel,
  } = ChannelActionCreators;
  const { createWarningAlert } = ActionCreators;
  const idx = _.findIndex(channels, { id: channelId });
  const isInChannel = currentChannelId === channelId;
  const isCurrentUser = userId === member.userId;

  if (idx === -1) { return; }

  if (isCurrentUser) {
    if (isInChannel) {
      if (member.deleted) {
        dispatch(createWarningAlert(i18n.t('removedFromChannel', { title: channels[idx].displayName })));
      }
      dispatch(setCurrentChannel(0));
    }
    dispatch(deleteChannel(channelId));
    return;
  } else if (isInChannel) {
    dispatch(deleteChannelMember(member));
  }
  dispatch(updateChannel({
    channelId,
    membersCount: channels[idx].membersCount - 1,
    hasPatient: channels[idx].hasPatient && member.user.roleId !== PATIENT_ID,
  }));
};

const websocketConnect = () => (dispatch, getState) => {
  if (getState().websocket.connected) return;

  // NOTE:
  // Just do something like container, passing action into websocket object.
  // So that websocket can dispatch action when receiving events.
  const allActions = {
    ...ChannelActionCreators,
    ...ActionCreators,
    websocketReceiveNewMessage,
    websocketReceiveNewMember,
    websocketReceiveAckMessage,
    websocketReceiveUpdateTitle,
    websocketReceiveDeletedMember,
  };
  WebSocketClient.setActions(bindActionCreators(allActions, dispatch));
  WebSocketClient.connect();
  dispatch({
    type: CONNECT_WEBSOCKET,
  });
};

const websocketDisconnect = () => (dispatch, getState) => {
  if (!getState().websocket.connected) return;

  WebSocketClient.disconnect();
  dispatch({
    type: DISCONNECT_WEBSOCKET,
  });
};

export default {
  websocketConnect,
  websocketDisconnect,
};



// WEBPACK FOOTER //
// ./src/actions/WebSocketActionCreators.js